// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API
export const ASSETS_API = import.meta.env.VITE_ASSETS_API
export const NETSUITE_API = {
  host : import.meta.env.VITE_NETSUITE_HOST_API
}

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  userPoolWebClientSecret: import.meta.env.VITE_AWS_AMPLIFY_CLIENT_SECRET,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
}

export const SES_API = {
  credentials: {
    accessKeyId: import.meta.env.VITE_KEY_ID,
    secretAccessKey: import.meta.env.VITE_KEY_SECRET
  },
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
}

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;
export const SENTRY_API = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
};
export const POSTHOG_API = {
  key: import.meta.env.VITE_POSTHOG_KEY,
  host: import.meta.env.VITE_POSTHOG_HOST,
};
export const ENV = import.meta.env.VITE_ENV;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = '/dashboard'
